(() => {
  const styleText = `
    [data-sf-popup-dialog] {
      position: fixed !important;
      inset: auto !important;
      top: 50dvh !important;
      right: auto !important;
      bottom: auto !important;
      left: 50vw !important;
      width: min(560px, calc(100vw - 48px)) !important;
      min-width: 0 !important;
      max-width: min(560px, calc(100vw - 48px)) !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: calc(100dvh - 48px) !important;
      margin: 0 !important;
      translate: none !important;
      transform: translate(-50%, -50%) !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      box-sizing: border-box !important;
      background-color: #101012 !important;
      background-image: linear-gradient(145deg, #171719 0%, #09090a 100%) !important;
      border: 1px solid rgba(255, 255, 255, 0.12) !important;
      border-radius: 20px !important;
      box-shadow: 0 24px 80px rgba(0, 0, 0, 0.42) !important;
    }

    [data-sf-popup-dialog],
    [data-sf-popup-dialog] * {
      box-sizing: border-box !important;
    }

    [data-sf-popup-background] {
      background-image: none !important;
      background-color: transparent !important;
    }

    [data-sf-popup-dialog] label {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }

    [data-sf-popup-hide] {
      display: none !important;
    }

    [data-sf-popup-title] {
      width: calc(100% - 96px) !important;
      max-width: 470px !important;
      margin: 0 auto 14px !important;
      color: #ffffff !important;
      font-size: clamp(32px, 3vw, 44px) !important;
      line-height: 1.05 !important;
      letter-spacing: -0.02em !important;
      text-align: center !important;
      text-wrap: balance !important;
      font-weight: 800 !important;
    }

    [data-sf-popup-support] {
      max-width: 460px !important;
      margin: 0 auto 16px !important;
      color: rgba(255, 255, 255, 0.84) !important;
      font-size: clamp(17px, 1.45vw, 21px) !important;
      line-height: 1.35 !important;
      text-align: center !important;
      font-weight: 600 !important;
    }

    [data-sf-popup-dialog] input[type="email"] {
      min-height: 54px !important;
      padding: 12px 16px !important;
      border: 1px solid rgba(255, 255, 255, 0.22) !important;
      border-radius: 8px !important;
      background: #ffffff !important;
      color: #111111 !important;
      font-size: 18px !important;
      line-height: 1.3 !important;
    }

    [data-sf-popup-dialog] input[type="email"]::placeholder {
      color: #666666 !important;
      opacity: 1 !important;
    }

    [data-sf-popup-dialog] button[type="submit"],
    [data-sf-popup-dialog] input[type="submit"] {
      min-height: 54px !important;
      border: 0 !important;
      border-radius: 8px !important;
      background: #e5231c !important;
      color: #ffffff !important;
      font-size: 18px !important;
      font-weight: 800 !important;
      letter-spacing: 0.05em !important;
    }

    [data-sf-popup-dialog] button[type="submit"]:hover,
    [data-sf-popup-dialog] input[type="submit"]:hover {
      background: #c91c16 !important;
    }

    [data-sf-popup-dialog] form {
      width: 100% !important;
      max-width: 520px !important;
      margin-right: auto !important;
      margin-left: auto !important;
    }

    [data-sf-popup-close] {
      position: absolute !important;
      top: 14px !important;
      right: 14px !important;
      z-index: 2147483647 !important;
      display: grid !important;
      width: 44px !important;
      min-width: 44px !important;
      height: 44px !important;
      min-height: 44px !important;
      padding: 0 !important;
      place-items: center !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #ffffff !important;
      box-shadow: none !important;
      font-size: 0 !important;
      line-height: 1 !important;
      opacity: 1 !important;
      visibility: visible !important;
      cursor: pointer !important;
    }

    [data-sf-popup-close]::after {
      content: "×" !important;
      display: block !important;
      color: #ffffff !important;
      font-family: Arial, sans-serif !important;
      font-size: 34px !important;
      font-weight: 300 !important;
      line-height: 1 !important;
    }

    [data-sf-popup-close] svg,
    [data-sf-popup-close] img {
      opacity: 0 !important;
    }

    [data-sf-popup-close]:focus-visible {
      outline: 2px solid #ffffff !important;
      outline-offset: 2px !important;
    }

    [data-sf-popup-dismiss] {
      color: rgba(255, 255, 255, 0.92) !important;
      font-size: 16px !important;
      font-weight: 600 !important;
      letter-spacing: 0.01em !important;
      line-height: 1.3 !important;
    }

    @media (max-width: 749px) {
      [data-sf-popup-dialog] {
        position: fixed !important;
        top: 50dvh !important;
        right: auto !important;
        bottom: auto !important;
        left: 50vw !important;
        width: min(360px, calc(100vw - 32px)) !important;
        max-width: min(360px, calc(100vw - 32px)) !important;
        max-height: calc(100dvh - 32px) !important;
        margin: 0 !important;
        translate: none !important;
        transform: translate(-50%, -50%) !important;
        border-radius: 16px !important;
      }

      [data-sf-popup-title] {
        width: calc(100% - 42px) !important;
        max-width: calc(100% - 42px) !important;
        margin: 0 auto 12px !important;
        font-size: clamp(30px, 8vw, 34px) !important;
        line-height: 1.04 !important;
        letter-spacing: -0.03em !important;
      }

      [data-sf-popup-support] {
        margin: 0 auto 14px !important;
        font-size: 18px !important;
        line-height: 1.35 !important;
        text-align: center !important;
      }

      [data-sf-popup-close] {
        top: 6px !important;
        right: 6px !important;
        width: 40px !important;
        min-width: 40px !important;
        height: 40px !important;
        min-height: 40px !important;
      }

      [data-sf-popup-close]::after {
        font-size: 32px !important;
      }

      [data-sf-popup-dialog] input[type="email"],
      [data-sf-popup-dialog] button[type="submit"],
      [data-sf-popup-dialog] input[type="submit"] {
        min-height: 56px !important;
        font-size: 18px !important;
      }

      [data-sf-popup-dialog] form {
        width: 100% !important;
        max-width: 100% !important;
        margin-right: auto !important;
        margin-left: auto !important;
      }
    }
  `;

  const copy = new Map([
    ['CONGRATULATIONS', 'SAVE ON YOUR FIRST FIX'],
    ['WELCOME TO SCRATCH FIX', 'SAVE ON YOUR FIRST FIX'],
    ["Ready to see what you've got? Enter your email below...", 'Get a welcome discount and expert repair tips.'],
    ['Enter your email to reveal your discount and get practical repair tips.', 'Get a welcome discount and expert repair tips.'],
    ['Get your discount code by email.', 'Get a welcome discount and expert repair tips.'],
    ['REVEAL CODE', 'EMAIL MY CODE'],
    ['REVEAL MY DISCOUNT', 'EMAIL MY CODE'],
    ['GET MY CODE', 'EMAIL MY CODE'],
    ["No thanks, I don't like discounts", 'No thanks'],
    ['No thanks, continue shopping', 'No thanks'],
    ['email', 'Email address']
  ]);

  const hiddenCopy = new Set([
    "YOU'VE UNLOCKED A MYSTERY DISCOUNT",
    "YOU'VE UNLOCKED",
    'A MYSTERY DISCOUNT',
    'UNLOCK YOUR WELCOME DISCOUNT',
    'UNLOCK YOUR',
    'WELCOME DISCOUNT'
  ]);

  const titleCopy = new Set(['CONGRATULATIONS', 'WELCOME TO SCRATCH FIX', 'SAVE ON YOUR FIRST FIX']);
  const supportCopy = new Set([
    "Ready to see what you've got? Enter your email below...",
    'Enter your email to reveal your discount and get practical repair tips.',
    'Get your discount code by email.',
    'Get a welcome discount and expert repair tips.'
  ]);
  const dismissCopy = new Set([
    "No thanks, I don't like discounts",
    'No thanks, continue shopping',
    'No thanks'
  ]);

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();

  const markCopyElements = (root) => {
    root.querySelectorAll('h1, h2, h3, h4, h5, p, [role="heading"], div, span').forEach((element) => {
      const value = normalize(element.textContent || '');
      if (!value) return;

      const upperValue = value.toUpperCase();
      const isDuplicateUnlockHeading = value.length < 80 && (
        upperValue.includes("YOU'VE UNLOCKED") ||
        upperValue === 'A MYSTERY DISCOUNT' ||
        upperValue === 'MYSTERY DISCOUNT' ||
        upperValue === 'UNLOCK YOUR WELCOME DISCOUNT' ||
        upperValue === 'WELCOME DISCOUNT'
      );

      if (hiddenCopy.has(value) || isDuplicateUnlockHeading) element.setAttribute('data-sf-popup-hide', 'true');
      if (titleCopy.has(value)) element.setAttribute('data-sf-popup-title', 'true');
      if (supportCopy.has(value)) element.setAttribute('data-sf-popup-support', 'true');
      if (dismissCopy.has(value)) element.setAttribute('data-sf-popup-dismiss', 'true');
    });
  };

  const replaceCopy = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      const value = normalize(node.nodeValue || '');
      const container = node.parentElement?.closest('p, h1, h2, h3, h4') || node.parentElement;

      if (hiddenCopy.has(value) && container) container.setAttribute('data-sf-popup-hide', 'true');
      if (titleCopy.has(value) && container) container.setAttribute('data-sf-popup-title', 'true');
      if (supportCopy.has(value) && container) container.setAttribute('data-sf-popup-support', 'true');
      if (dismissCopy.has(value) && container) container.setAttribute('data-sf-popup-dismiss', 'true');

      const replacement = copy.get(value);
      if (replacement !== undefined) node.nodeValue = replacement;
      node = walker.nextNode();
    }

    markCopyElements(root);
  };

  const removeDecorativeBackgrounds = (dialog) => {
    dialog.querySelectorAll('div, section, form').forEach((element) => {
      if (window.getComputedStyle(element).backgroundImage !== 'none') {
        element.setAttribute('data-sf-popup-background', 'true');
      }
    });
  };

  const isScratchFixPopup = (dialog) => {
    const value = normalize(dialog.textContent || '').toLowerCase();
    return value.includes('mystery discount') ||
      value.includes('reveal code') ||
      value.includes('welcome discount') ||
      value.includes('reveal my discount') ||
      value.includes('save on your first fix') ||
      value.includes('get my code');
  };

  const findCloseButton = (dialog) => {
    const explicit = dialog.querySelector([
      'button[aria-label*="close" i]',
      '[role="button"][aria-label*="close" i]',
      'button[class*="close" i]',
      '[role="button"][class*="close" i]',
      'button[class*="dismiss" i]',
      '[role="button"][class*="dismiss" i]'
    ].join(','));

    if (explicit) return explicit;

    const dialogRect = dialog.getBoundingClientRect();
    return Array.from(dialog.querySelectorAll('button, [role="button"]')).find((button) => {
      const value = normalize(button.textContent || '').toLowerCase();
      if (value === '×' || value === 'x' || value === 'close') return true;

      const rect = button.getBoundingClientRect();
      return rect.width <= 64 && rect.height <= 64 && rect.top <= dialogRect.top + 80 && rect.right >= dialogRect.right - 80;
    }) || null;
  };

  const applyEnhancements = (dialog) => {
    if (!dialog.hasAttribute('data-sf-popup-dialog') && !isScratchFixPopup(dialog)) return;

    dialog.setAttribute('data-sf-popup-dialog', 'true');

    const closeButton = findCloseButton(dialog);
    if (closeButton) {
      if (closeButton.parentElement !== dialog) dialog.appendChild(closeButton);
      closeButton.setAttribute('data-sf-popup-close', 'true');
      closeButton.setAttribute('aria-label', 'Close signup offer');
      closeButton.setAttribute('title', 'Close');
    }

    replaceCopy(dialog);
    removeDecorativeBackgrounds(dialog);

    const emailInput = dialog.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.setAttribute('placeholder', 'Email address');
      emailInput.setAttribute('autocomplete', 'email');
      emailInput.setAttribute('inputmode', 'email');
    }
  };

  const ensureStyle = (root) => {
    if (!root.querySelector('[data-sf-popup-ux-style]')) {
      const style = document.createElement('style');
      style.setAttribute('data-sf-popup-ux-style', 'true');
      style.textContent = styleText;
      if (root === document) {
        document.head.appendChild(style);
      } else {
        root.appendChild(style);
      }
    }
  };

  const enhanceRoot = (root, marker) => {
    ensureStyle(root);
    root.querySelectorAll('[role="dialog"]').forEach(applyEnhancements);

    if (!marker.hasAttribute('data-sf-popup-ux-ready')) {
      marker.setAttribute('data-sf-popup-ux-ready', 'true');
      new MutationObserver(() => {
        root.querySelectorAll('[role="dialog"]').forEach(applyEnhancements);
      }).observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };

  const scan = () => {
    enhanceRoot(document, document.documentElement);
    document.querySelectorAll('oneclickpopup-widget').forEach((widget) => {
      enhanceRoot(widget.shadowRoot || widget, widget);
    });
  };

  scan();
})();
